import ListHeaderLabel from './ListHeaderLabel';

export default ListHeaderLabel;
